/**
 * Created by alex.shmaltsuev on 2016-05-09.
 */
import PropTypes from 'prop-types';

import React from 'react';
import Style from './fullTab.scss';
import StyledPagination from '../utils/Styled/pagination';
import C from '../../constants/scoreBoard';

/**
 * returns a react object of the fullTab contain all of data for the tabs
 */
class FullTab extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            checkAllArray: this.initCheckAllArray()
        };
    }

    /**
     * array with the check All . The length of this array is as the number of pagination 
     * @returns {Array}
     */
    initCheckAllArray() {
        let arr = [];
        let numberOfPages = Math.ceil(this.props.listItems.length / C.ELEMENT_PER_PAGINATION);
        for (let i = 0; i < numberOfPages; i++) {
            arr[i] = false;
        }
        return arr;
    }

    /**
     * initialize the state of the tab
     * @returns {Array}
     */
    initState() {
        let checkAllArray = this.initCheckAllArray();
        this.setState({
            checkAllArray: checkAllArray,
            activePage:1
        });
    }

    render() {
      
        let numberOfPages = this.props.paginationPageCount || Math.ceil(this.props.listItems.length / C.ELEMENT_PER_PAGINATION);
        let slicedListItems = this.props.customPagination?this.props.listItems:this.props.listItems.slice( C.ELEMENT_PER_PAGINATION * (this.state.activePage-1),  C.ELEMENT_PER_PAGINATION * this.state.activePage);
      
        let pagination;
        if (numberOfPages > 1) {
            pagination = <StyledPagination aria-label={this.props.intlObject['ssp.scoreboard.pagination']} tabIndex='0' className={ Style.pagination }
                                     activePage={this.state.activePage}
                                     items={numberOfPages}
                                     onSelect={ this.handleSelect.bind(this)}
                                     maxButtons={3}
                                     boundaryLinks={true}
                                     />;
        }

        return (
            <span>
                {slicedListItems}
                {pagination}
             </span>
        )
    }

   

    /**
     * update the pagination active page
     * @param event
     * @param eventKey
     */
    handleSelect(eventKey) {
        this.setState({
            activePage: eventKey
        });
        this.props.customPagination&&this.props.customPagination(eventKey);
    }
}


FullTab.propTypes = {
    listItems: PropTypes.array.isRequired,
    intlObject: PropTypes.object.isRequired,
    customPagination:PropTypes.func,
    paginationPageCount: PropTypes.number
}

export default FullTab;


// WEBPACK FOOTER //
// ./components/Scoreboard/fullTab.js